<template>
  <v-container fluid class="pa-0">
    <!--app-bar-->
    <v-app-bar flat color="red-darken-3">
      <!--Title-->
      <v-app-bar-title class="text-white hidden-sm-and-down">
        {{ $t("car_locations.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <!--Search-->
      <v-text-field
        v-model="search"
        :label="$t('car_locations.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        class="ml-12"
        single-line
        hide-details
      />
      <v-spacer />
      <!--QR Scanner-->
      <v-btn
        color="grey-darken-4"
        class="mx-1 hidden-sm-and-down"
        variant="flat"
        @click="openQrScanner"
      >
        {{ $t("parts.inventory.scan_qr") }}
        <v-icon end> mdi-qrcode </v-icon>
      </v-btn>
      <!--Print Locations-->
      <v-btn
        color="grey-darken-4"
        class="mx-1 hidden-sm-and-down"
        variant="flat"
        @click="printCarLocations"
      >
        {{ $t("car_locations.print") }}
        <v-icon end>mdi-printer</v-icon>
      </v-btn>
      <!--New Location-->
      <v-btn
        color="grey-darken-4"
        variant="flat"
        class="mx-1"
        @click="newCarLocation"
      >
        {{ $t("car_locations.new_location") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>
    <!--DATATABLE-->
    <datatable
      ref="datatable"
      :search="search"
      @qr="openQrDialog"
      @cars-list="viewCarsList"
      @edit="editCarLocation"
    />
    <!--CARS LIST-->
    <cars-list ref="carsList" @qr="openQrDialog" />
    <!--DIALOG-->
    <edit-dialog ref="dialog" @save="getCarLocations" />
    <!--QR DIALOG-->
    <qr-dialog ref="qrDialog" />
    <!--QR SCANNER-->
    <qr-scanner ref="qrScanner" @list="viewCarsList" @edit="editCarLocation" />
  </v-container>
</template>

<script>
import Datatable from "@/components/CarLocations/datatable.vue";
import CarsList from "@/components/CarLocations/carsList.vue";
import EditDialog from "@/components/CarLocations/editDialog.vue";
import QrDialog from "@/components/qrDialog.vue";
import QrScanner from "@/components/CarLocations/qrScanner.vue";
import Print from "@/components/CarLocations/print";

export default {
  components: {
    datatable: Datatable,
    "cars-list": CarsList,
    "edit-dialog": EditDialog,
    "qr-dialog": QrDialog,
    "qr-scanner": QrScanner,
  },
  data: () => ({
    search: "",
  }),
  methods: {
    newCarLocation() {
      const { dialog } = this.$refs;
      dialog.open(false, null);
    },
    openQrDialog(data) {
      const { qrDialog } = this.$refs;
      qrDialog.open(data);
    },
    openQrScanner() {
      const { qrScanner } = this.$refs;
      qrScanner.open();
    },
    viewCarsList(data) {
      const { carsList } = this.$refs;
      carsList.open(data);
    },
    editCarLocation(data) {
      const { dialog } = this.$refs;
      dialog.open(true, data);
    },
    getCarLocations() {
      const { datatable } = this.$refs;
      datatable.getCarLocations();
    },
    printCarLocations() {
      const { datatable } = this.$refs;
      Print(datatable.carLocations);
    },
  },
};
</script>
